<template lang="pug">
div.animated.fadeIn
  // conclusion by duration
  b-card
    div.row
      div.col-sm-4
      div.col-sm-8
        div.dateRangePickerContainer
          i(class="fa fa-calendar")
          date-range-picker.ml-2.dateRangePicker(ref="ref" :options="options")
          i(class="fa fa-caret-down")
    br
    div(id='interactionContainer' style='height: 300px')
    div(id='userContainer' style='height: 300px')
</template>

<script>
// import { db } from '@/firebase'
import echarts from 'echarts'
import $ from 'jquery'
var moment = require('moment')
// const anaRef = db.ref('analytics')

export default {
  name: 'dashboard',
  data() {
    let thisYear = moment().startOf('year').format('YYYY')
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      // for date range picker
      options: {
        startDate: moment().startOf('year'),
        locale: {
          format: 'YYYY',
        },
        singleDatePicker: true,
        showCustomRangeLabel: false,
        showDropdowns: false,
        ranges: {
          [`${thisYear}`]: [moment().startOf('year')],
          [`${thisYear - 1}`]: [moment().subtract(1, 'year').startOf('year')],
          [`${thisYear - 2}`]: [moment().subtract(2, 'year').startOf('year')],
          [`${thisYear - 3}`]: [moment().subtract(3, 'year').startOf('year')],
          [`${thisYear - 4}`]: [moment().subtract(4, 'year').startOf('year')],
        },
      },
      range: moment().startOf('year').format('YYYY'),
      yAxisLabels: [],
      option: null,
    }
  },
  mounted: function() {
    const el = $(this.$refs.ref.$el)
    const that = this
    el.on('apply.daterangepicker', (event, picker) => {
      that.range = `${picker.startDate.format('YYYY')}`
      let userMaximum = 0
      let interactionMaximum = 0
      Object.entries(this.fullData).forEach(function([key, val]) {
        const year = key.substring(0, 4)
        if (year == that.range) {
          userMaximum = Math.max(userMaximum, val.totals.users ? val.totals.users.total : 0)
          interactionMaximum = Math.max(interactionMaximum, val.totals.interactions ? val.totals.interactions.total : 0)
        }
      })
      this.setOption(this.range, this.yAxisLabels, this.numberOfUsers, this.numberOfInteractions, userMaximum, interactionMaximum)
      var userContainerDom = document.getElementById('userContainer')
      var interactionContainerDom = document.getElementById('interactionContainer')
      var userChart = echarts.init(userContainerDom)
      var interactionChart = echarts.init(interactionContainerDom)
      userChart.setOption(this.userOption, true)
      interactionChart.setOption(this.interactionOption, true)
    })
    this.getGraph()
  },
  methods: {
    getGraph() {
      // const that = this
      var userContainerDom = document.getElementById('userContainer')
      var interactionContainerDom = document.getElementById('interactionContainer')
      var userChart = echarts.init(userContainerDom)
      var interactionChart = echarts.init(interactionContainerDom)
      let userMaximum = 1000
      let interactionMaximum = 1000
      // let yAxisLabels = []
      let numberOfUsers = []
      let numberOfInteractions = []
      // let lastDay = ''
      function getVirtulData(year) {
        year = year || '2017'
        var date = +echarts.number.parseDate(year + '-01-01')
        var end = +echarts.number.parseDate((+year + 1) + '-01-01')
        var dayTime = 3600 * 24 * 1000
        var data = []
        for (var time = date; time < end; time += dayTime) {
          data.push([
            echarts.format.formatTime('yyyy-MM-dd', time),
            Math.floor(Math.random() * 1000),
          ])
        }
        return data
      }
      numberOfUsers = getVirtulData(2019)
      numberOfInteractions = getVirtulData(2019)
      // Object.entries(sampleData).forEach(function([key, val]) {
      //   const day = key.substring(6)
      //   const month = key.substring(4, 6)
      //   const year = key.substring(0, 4)
      //   var date = +echarts.number.parseDate(`${year}-${month}-${day}`)
      //   // lastDay = echarts.number.parseDate(`${year}-${month}-${day}`)
      //   numberOfUsers.push([
      //     echarts.format.formatTime('yyyy-MM-dd', date),
      //     val.totals.users ? val.totals.users.total : 0,
      //   ])
      //   userMaximum = Math.max(userMaximum, val.totals.users ? val.totals.users.total : 0)
      //   numberOfInteractions.push([
      //     echarts.format.formatTime('yyyy-MM-dd', date),
      //     val.totals.interactions ? val.totals.interactions.total : 0,
      //   ])
      //   interactionMaximum = Math.max(interactionMaximum, val.totals.interactions ? val.totals.interactions.total : 0)
      // })
      if (this.initialise) {
        this.numberOfUsers = numberOfUsers
        this.numberOfInteractions = numberOfInteractions
        this.userMaximum = userMaximum
        this.interactionMaximum = interactionMaximum
        this.initialise = false
      }
      this.setOption(this.range, this.yAxisLabels, this.numberOfUsers, this.numberOfInteractions, this.userMaximum, this.interactionMaximum)
      if (this.userOption && typeof this.userOption === 'object') {
        userChart.setOption(this.userOption, true)
        interactionChart.setOption(this.interactionOption, true)
      }
    },
    setOption(range, yAxisLabels, numberOfUsers, numberOfInteractions, userMaximum, interactionMaximum) {
      this.userOption = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Daily Number of Visitors Heatmap',
        },
        tooltip: {
          formatter: function(c0) {
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            const lastDay = `${c0.data[0].substring(8, 10)} ${monthNames[parseInt(c0.data[0].substring(5, 7)) - 1]}`
            return `${lastDay} - ${c0.data[1]}`
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000',
          },
          position: 'top',
        },
        visualMap: {
          type: 'continuous',
          min: 0,
          max: userMaximum,
          itemWidth: 20,
          calculable: true,
          text: ['Busy', 'Quiet'],
          textStyle: {fontWeight: 'bold', fontSize: 10},
          orient: 'horizontal',
          color: ['#6fdebd', '#fafffd'],
          right: 80,
          top: 10,
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false,
            },
            restore: {},
            saveAsImage: {},
          },
        },
        calendar: [
          {
            yearLabel: {
              formatter: 'Visitors',
              textStyle: {
                fontSize: 14,
                color: '#666',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#666',
                width: 2,
                type: 'solid',
              },
            },
            dayLabel: {firstDay: 1},
            top: '80',
            left: '80',
            right: '50',
            range,
            cellSize: ['auto', 20],
          },
        ],
        series: [{
          type: 'heatmap',
          coordinateSystem: 'calendar',
          calendarIndex: 0,
          data: numberOfUsers,
        }],
      }

      this.interactionOption = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Daily Visitor Interactions Heatmap',
        },
        tooltip: {
          formatter: function(c0) {
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            const lastDay = `${c0.data[0].substring(8, 10)} ${monthNames[parseInt(c0.data[0].substring(5, 7)) - 1]}`
            return `${lastDay} - ${c0.data[1]}`
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000',
          },
          position: 'top',
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false,
            },
            restore: {},
            saveAsImage: {},
          },
        },
        visualMap: {
          type: 'continuous',
          min: 0,
          max: interactionMaximum,
          itemWidth: 20,
          calculable: true,
          text: ['Busy', 'Quiet'],
          textStyle: {fontWeight: 'bold', fontSize: 10},
          orient: 'horizontal',
          color: ['#32b5d9', '#fafeff'],
          right: 80,
          top: 10,
        },
        calendar: [
          {
            yearLabel: {
              formatter: 'Visitor Interactions',
              textStyle: {
                fontSize: 14,
                color: '#666',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#666',
                width: 2,
                type: 'solid',
              },
            },
            dayLabel: {firstDay: 1},
            top: 100,
            left: '80',
            right: '50',
            range,
            cellSize: ['auto', 20],
          },
        ],
        series: [{
          type: 'heatmap',
          coordinateSystem: 'calendar',
          calendarIndex: 0,
          data: numberOfInteractions,
        }],
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Analytics/DailyVisitor.vue?c0c2a428